<template>
    <div class="page-not-developed">
      <h1>此頁面尚未開發</h1>
      <p>該頁面目前尚未製作，<router-link :to="`/dashboard`">回到首頁</router-link>。</p>
    </div>
  </template>
  
  <script>
  export default {
    name: 'PageNotDeveloped',
  };
  </script>
  
  <style scoped>
  .page-not-developed {
    text-align: center;
    padding: 50px;
  }
  </style>